import React from 'react';
import PropTypes from 'prop-types';
import { GridContainer, GridWrapper } from './styles.js';
import { COLUMN_SIZE_PROPTYPE } from './constants.js';

export const Grid = ({
  gap = {},
  children,
  columns = {},
  backgroundColor = 'background.lightest',
  mobileWidth = 100,
  width = 100,
  marginTop = 0,
  marginBottom = 0,
  maxWidth = null,
}) => {
  const columnsValues =
    typeof columns === 'number'
      ? { mobile: columns, laptop: columns, tablet: columns }
      : columns;

  return (
    <GridWrapper
      $backgroundColor={backgroundColor}
      $marginTop={marginTop}
      $marginBottom={marginBottom}
    >
      <GridContainer
        $maxWidth={maxWidth}
        $mobileWidth={mobileWidth}
        $width={width}
        $gap={gap}
        $mobile={columnsValues.mobile}
        $laptop={columnsValues.laptop}
        $tablet={columnsValues.tablet}
      >
        {children}
      </GridContainer>
    </GridWrapper>
  );
};

Grid.displayName = 'Grid';

Grid.propTypes = {
  columns: PropTypes.oneOfType([
    COLUMN_SIZE_PROPTYPE,
    PropTypes.shape({
      mobile: COLUMN_SIZE_PROPTYPE,
      laptop: COLUMN_SIZE_PROPTYPE,
      tablet: COLUMN_SIZE_PROPTYPE,
    }),
  ]),
  gap: PropTypes.shape({
    row: PropTypes.number,
    column: PropTypes.number,
  }),
  children: PropTypes.node.isRequired,
  mobileWidth: PropTypes.number,
  width: PropTypes.number,
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
};
